import React from "react";

import { CRM_SOURCE_TYPES } from "../../SourceCreation.constants";

/**
 * Renders the `source_types/*` component registered for `sourceType`.
 * Children report success via `handleClose(sourceId)` and cancel via
 * `handleClose()`; some also report their internal step through
 * `blockerProp` so the host can hide the source type select. Components
 * flagged `useHostFooter` register their primary action with the modal
 * footer via `registerFooterAction` instead of rendering their own buttons.
 */
const CrmSourceForm = ({
    sourceType,
    hostActions,
    onClose,
    setLoading,
    setTypeSelectBlocked,
    registerFooterAction,
}) => {
    const config = CRM_SOURCE_TYPES[sourceType];
    if (!config) return null;

    const { Component, blockerProp, useHostFooter = false } = config;
    const blockerProps = blockerProp
        ? {
              [blockerProp]: (value) =>
                  setTypeSelectBlocked(sourceType, Boolean(value)),
          }
        : {};

    return (
        <Component
            handleClose={onClose}
            handleGetSources={hostActions.handleGetSources}
            getTracker={hostActions.getTracker}
            addToTracker={hostActions.addToTracker}
            setLoading={setLoading}
            useHostFooter={useHostFooter}
            registerFooterAction={
                useHostFooter ? registerFooterAction : undefined
            }
            {...blockerProps}
        />
    );
};

export default CrmSourceForm;
